import Ajax from "./Ajax";

const doc = document;
const ID_MAIN_NAV = '#menu-hauptnavigation';
const ID_FOOTER_NAV = '#menu-fußnavigation';
const ID_BURGER = '#burger';
const CLASS_ACTIVE_SUBMENU = 'active-submenu';
const CLASS_MAIN_NAV = '.menu-hauptnavigation-container';
const CLASS_HAS_SUBMENU = 'menu-item-has-children';
const CLASS_CAREER_BUTTON = '.career-button__button';
const CLASS_NAV_ELE_CLASS = '.main-navigation';
const CLASS_BACKLINKBAR = '.backlink-bar';

let lastClickedNav: HTMLAnchorElement;
let burgerEl: HTMLElement;
let navElements: Array<Element>;
let obj: Navigation;
let backlinkBarEl: HTMLElement;
let mobileMenu = false;

export default class Navigation  {

  constructor() {
    obj = this;

    this.render();
  }

  async render() {

    if(document.querySelector(CLASS_NAV_ELE_CLASS)){
      obj.renderMainNav();
    }else{
      document.getElementById("main-body").style.marginTop = "0rem";
    }
    obj.getOpenJobNumber().then(response => {
        obj.setCareerPinBanner(response);
    })

  }

  subMenuClick(this: HTMLAnchorElement) {
    doc.querySelector('.'+CLASS_ACTIVE_SUBMENU)?.classList.remove(CLASS_ACTIVE_SUBMENU);

    Array.from(doc.querySelectorAll('.sub-menu-wrap')).forEach(subNavEl => {
        subNavEl.setAttribute('aria-hidden', 'true');
    })

    if(lastClickedNav != this) {
      this.classList.add(CLASS_ACTIVE_SUBMENU);
      this.querySelector('.sub-menu-wrap')?.setAttribute('aria-hidden', 'false');
      lastClickedNav = this;
    }else{
      lastClickedNav = null;
    }
  }

  setCareerPin(nbr: string) {
      let careerPin = document.createElement('label');
      careerPin.classList.add('career-button__pin');
      careerPin.innerHTML = nbr;
      doc.querySelector(CLASS_CAREER_BUTTON + ' a').appendChild(careerPin);
  }

  setCareerPinBanner(nbr: any) {
          let careerPin = document.createElement('label');
          careerPin.classList.add('career-button__pin');
          careerPin.innerHTML = String(nbr);
          doc.querySelector('#career-banner ' + CLASS_CAREER_BUTTON).appendChild(careerPin);
  }

  setBacklinkBarHeight(nbr: string) {
    backlinkBarEl.style.height = nbr + 'px';
  }

  openBurgerMenu(){
        let mainNavEl = <HTMLElement>doc.querySelector(CLASS_MAIN_NAV);
        if(mobileMenu){
           mainNavEl.style.display = 'none';
            Array.from(burgerEl.children).forEach(barEl => {
                barEl.classList.remove('change');
            });
            mobileMenu = false;

            let navEle = <HTMLElement>document.querySelector(CLASS_NAV_ELE_CLASS);
            navEle.style.height = 'initial';
            navEle.style.overflowY = 'inital';

        }else{
            mainNavEl.style.display = 'block';
            Array.from(burgerEl.children).forEach(barEl => {
                barEl.classList.add('change');
            });
            mobileMenu = true;

            let navEle = <HTMLElement>document.querySelector(CLASS_NAV_ELE_CLASS);
            navEle.style.height = '100%';
            navEle.style.overflowY = 'scroll';
        }
    }

  renderMainNav() :void {
    navElements = Array.from(doc.querySelectorAll('#menu-hauptnavigation > li'));
    burgerEl = doc.querySelector('#burger');
    backlinkBarEl = document.querySelector(CLASS_BACKLINKBAR);

    navElements.forEach(navElement => {
        if(navElement.classList.contains(CLASS_HAS_SUBMENU)) {
            navElement.addEventListener('click', obj.subMenuClick);
        }
    });
    burgerEl.addEventListener('click', event => obj.openBurgerMenu());

    if(backlinkBarEl != null) {
        document.addEventListener('scroll', (event) => {
            if(document.querySelector('html').scrollTop > 30) {
                obj.setBacklinkBarHeight('0');
            } else {
                obj.setBacklinkBarHeight('33');
            }
        });
    }

    obj.getOpenJobNumber().then(response => {
        obj.setCareerPin(response);
    })
    let carrerButtonLinkEl = doc.querySelector(CLASS_CAREER_BUTTON + ' a');
    carrerButtonLinkEl.id = 'karriere';
  }

  async getOpenJobNumber() {
      const ajaxObj = new Ajax();
      try {
          let datapool = {ajaxurl: '/wp-content/themes/haas-medien/assets/jobcount.json'};

          let resp = ajaxObj.makeRequest('get', datapool, {}, false);
          if (resp.readyState == XMLHttpRequest.DONE) {
              if (resp.responseText != '' && resp.status != 404) {
                  let nbrJson = JSON.parse(resp.responseText);
                  return nbrJson['offers'];
              }
          }
      }catch (error){
          console.error(error);
      }
  }

}